export const CMI_LINK = 'https://childmind.org';
export const PRIVACY_LINK = 'https://www.gettingcurious.com/privacy-policy';
export const TERMS_LINK = 'https://www.gettingcurious.com/terms';
export const ABOUT_LINK = 'https://www.gettingcurious.com';
export const CREDITS_LINK = 'https://www.gettingcurious.com/open-source-credits';
export const SUPPORT_LINK = 'https://help.gettingcurious.com';
